/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sheet_Drag_CloseInputs */

const en_ui_sheet_drag_close = /** @type {(inputs: Ui_Sheet_Drag_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag to close`)
};

const de_ui_sheet_drag_close = /** @type {(inputs: Ui_Sheet_Drag_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Schließen ziehen`)
};

/**
* | output |
* | --- |
* | "Drag to close" |
*
* @param {Ui_Sheet_Drag_CloseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sheet_drag_close = /** @type {((inputs?: Ui_Sheet_Drag_CloseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sheet_Drag_CloseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sheet_drag_close(inputs)
	return de_ui_sheet_drag_close(inputs)
});